import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

const Spinner = ({ className, color, center, ...restProps }) => (
  <div
    className={classnames(styles.wrapper, {
      [styles.center]: center,
    })}
  >
    <svg
      className={classnames(styles.svg, className)}
      width="40"
      height="40"
      viewBox="0 0 66 66"
      {...restProps}
    >
      <circle cx="33" cy="33" r="30" stroke={color} />
    </svg>
  </div>
)

Spinner.propTypes = {
  className: PropTypes.string,
  center: PropTypes.bool,
  color: PropTypes.string,
}

Spinner.defaultProps = {
  className: '',
  center: false,
  color: '#000',
}

export default Spinner



// WEBPACK FOOTER //
// ../source/components/Spinner/index.js